/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Container } from './styles';

interface BannerAuthenticateDocumentProps {
  show?: boolean;
  onClose?: () => void;
}

const BannerAuthenticateDocumentModal = ({ show, onClose }: BannerAuthenticateDocumentProps) => {
  const [internalShow, setInternalShow] = useState(false);

  const handleClose = () => {
    setInternalShow(false);
    if (onClose) onClose();
  };

  const shouldShow = internalShow || show;

  return (
    <Modal size="lg" show={shouldShow} onHide={handleClose}>
      <Container>
        <div className="modal-body bg-modal m-3">
          <button aria-label="Close" className="close" onClick={handleClose} type="button">
            <span aria-hidden="true">×</span>
          </button>
          <span className="badge badge-warning text-uppercase mb-2">
            Novidade no Gerenciar documentos
          </span>
          <h3 className="mb-3">
            Autentique seus documentos <br />
            com apenas um clique
          </h3>
          <div className="row">
            <div className="col-12 col-md-6 font-scale">
              <p className="pb-2">
                O Gerenciar Documentos acaba de ganhar uma nova funcionalidade:{' '}
                <strong>Autenticação de Documentos</strong>.
              </p>
              <p className="pb-2">
                Agora, você pode autenticar facilmente todos os seus arquivos em formato .pdf, em
                apenas alguns cliques.
              </p>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  window.location.href = '/documentos';
                  handleClose();
                }}
              >
                Confira agora
              </button>
            </div>
          </div>
        </div>
      </Container>
    </Modal>
  );
};

export default BannerAuthenticateDocumentModal;
